import { render, staticRenderFns } from "./categoryDialog copy.vue?vue&type=template&id=491aaf66&scoped=true"
import script from "./categoryDialog copy.vue?vue&type=script&lang=js"
export * from "./categoryDialog copy.vue?vue&type=script&lang=js"
import style0 from "./categoryDialog copy.vue?vue&type=style&index=0&id=491aaf66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491aaf66",
  null
  
)

export default component.exports